/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Registration_Closed_TitleInputs */

const en_registration_closed_title = /** @type {(inputs: Registration_Closed_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`About the application phase`)
};

const de_registration_closed_title = /** @type {(inputs: Registration_Closed_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hinweis zur Bewerbungsphase`)
};

/**
* | output |
* | --- |
* | "About the application phase" |
*
* @param {Registration_Closed_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const registration_closed_title = /** @type {((inputs?: Registration_Closed_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Registration_Closed_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_registration_closed_title(inputs)
	return en_registration_closed_title(inputs)
});